import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams, useNavigate, useLocation } from "react-router";
import Loader from "../../components/Common/Loader/Loader";
import {
  authenticateAADUser,
  authenticateAADUserForLighthouse,
} from "../../store/actions/actionHandlers/loginActionHandler";
import getTenantName from "../../utils/getTenantName";
import { domains, isMatchingDomain } from "../../utils/ltimSSOLoginCondition";

const AADLoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const tenantName = getTenantName(dispatch, location);

  useEffect(() => {
    let securityProviderName = localStorage.getItem("SecurityProviderName");
    if (securityProviderName !== "aad" && params?.token) {
      const tenantName = localStorage.getItem("tenantName");
      let headers = {
        AuthenticationToken: decodeURIComponent(params?.token),
        "Content-Type": "application/json",
        TenantSlugName: tenantName,
      };
      localStorage.setItem("token", params?.token);
      localStorage.setItem("headers", JSON.stringify(headers));
      navigate(`/${tenantName}/home`);
    }
  }, [params?.token, navigate]);

  useEffect(() => {
    debugger;
    const securityProviderName = (
      localStorage.getItem("SecurityProviderName") || ""
    ).toLowerCase();
    const tenantData = JSON.parse(localStorage.getItem("tenantData") || "{}");
    const isHybridTenant = tenantData?.SAMLConfig?.IdentityType === 2;
    const isHybridFlow = !!location.state?.fromHybridTenant;

    if (
      params?.token ||
      ["saml2", "custom"].includes(securityProviderName) ||
      (isHybridTenant && isHybridFlow)
    ) {
      return;
    }

    if (isMatchingDomain(domains)) {
      dispatch(authenticateAADUserForLighthouse(navigate, location));
    } else if (securityProviderName === "aad") {
      dispatch(authenticateAADUser(navigate));
    }
  }, [dispatch, navigate, params?.token]);

  return <Loader message={"Authenticating..."} page />;
};

export default AADLoginPage;
